import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UploaderService } from '../../services/uploader.service';
import { IImage, IInteractionType } from '../../interfaces/definitions';
import { DetailPanelService } from '../../services/detail-panel.service';
import { Storage } from '../../services/storage';

@Component({
  selector: 'ng-media-file-explorer',
  templateUrl: './file-explorer.component.html',
  styleUrls: ['./file-explorer.component.scss']
})
export class NgMediaFileExplorerComponent implements OnInit {
  @Input() public items: Array<IImage> = [];
  @Input() public storage: Storage = null;
  @Input() public type: 'multiselect' | 'singleselect' | 'details' =
    'singleselect';
  @Input() public class = '';

  @Output() public selectionChange: EventEmitter<
    Array<IImage>
  > = new EventEmitter();
  @Input() public InteractionType: IInteractionType = IInteractionType.Edit;

  constructor(
    private uploader: UploaderService,
    private panel: DetailPanelService
  ) {}

  ngOnInit() {}

  public ImageSelect(image: IImage) {
    if (this.type === 'multiselect') {
      this.items = this.uploader.multipleSelectImage(image, this.items);
    }
    if (this.type === 'singleselect') {
      this.items = this.uploader.selectImage(image, this.items);
    }
    if (this.type === 'details') {
      this.items = this.uploader.selectImage(image, this.items);
      this.uploader.photoSelector.emit(image);
      this.panel.showDetaile(image, this.storage);
    }

    this.selectionChange.emit(this.items);
  }
}
